import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { useSiteConfig } from 'libs/common/hooks';
import { useUserRoles } from 'libs/content/hooks';
import client from 'services/networking/client';
import { NotAllowed } from '../pages/notAllowed';
export var withAuthSync = function withAuthSync(Component, requiredRight) {
  var _ref2, _Component$displayNam;

  var WrappedComponent = function WrappedComponent(props) {
    var _useSiteConfig = useSiteConfig(),
        site = _useSiteConfig.id;

    var _useUserRoles = useUserRoles(),
        isAllowed = _useUserRoles.isAllowed,
        isSiteAllowed = _useUserRoles.isSiteAllowed;

    var _useState = useState(false),
        isUserAllowed = _useState[0],
        setIsUserAllowed = _useState[1];

    useEffect(function () {
      void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return client.checkToken();

              case 2:
                setIsUserAllowed(requiredRight === undefined ? isSiteAllowed(site) : isAllowed(site, requiredRight));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }, [isAllowed, isSiteAllowed, site]);

    if (!client.isAuthenticated) {
      return __jsx(React.Fragment, null);
    }

    return isUserAllowed ? __jsx(Component, props) : __jsx(NotAllowed, null);
  };

  WrappedComponent.displayName = "withAuthSync(".concat((_ref2 = (_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : Component.name) !== null && _ref2 !== void 0 ? _ref2 : 'Component', ")");
  return WrappedComponent;
};